<template>
  <div>
    <div class="inputCard">
      <header class="pointer" @click="toggleAccordion()" :style="accordion.sidebar ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.sidebar ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Sidebar</header>
      <div class="content" v-if="accordion.sidebar">
        <div class="cardRow w3-padding-8">
          <label>Enabled</label>
          <div class="w3-right-align">
            <label class="switch">
              <input type="checkbox" v-model="state.siteData.pages.home.sections.sidebar.enabled">
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <template v-if="state.siteData.pages.home.sections.sidebar.enabled">
          <!-- Sidebar -->
          <div class="inputCard">
            <header>Sidebar Configuration</header>
            <div class="content">
              <div class="cardRow w3-padding-8" v-for="(item, index) in Object.keys(state.siteData.content.sidebar.sections)" :key="index">
                <label>{{ item | capitalize }}</label>
                <div class="w3-right-align">
                  <label class="switch">
                    <input type="checkbox" v-model="state.siteData.content.sidebar.sections[item].enabled">
                    <span class="slider"></span>
                  </label>
                </div>
              </div>
              <template v-if="state.siteData.content.sidebar.sections.custom.enabled">
                <div class="input-row w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
                  <label class="w3-label">Sidebar Custom Content</label>
                  <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="state.siteData.content.sidebar.sections.custom.content"></tinymce-editor>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var dataStore = require('@/dataStore').default

export default {
  name: 'cmssidebar',
  data() {
    return {
      state: dataStore.state
    }
  },
  props: {
    accordion: Object
  },
  components: {
    'tinymce-editor': Editor
  },
  methods: {
    toggleAccordion() {
      this.$emit('toggleAccordion', !this.accordion.sidebar)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cms/pages/home/cmsSidebar.vue